import { v4 as uuid } from 'uuid';
import { CONTENT_NOTIFICATION_DELIVERY_TYPES } from 'constants-notifications';

export default function constructNotification({
  userId,
  sendAt,
  contentId,
  title = '',
  title_l10n = {},
  contentGoesLiveNotification = false,
  deliveryTypes = CONTENT_NOTIFICATION_DELIVERY_TYPES,
}: any) {
  return {
    _id: uuid(),
    _created: new Date(),
    _updated: new Date(),
    _createdBy: userId,
    _updatedBy: userId,
    contentGoesLiveNotification,
    title,
    title_l10n,
    deliveryTypes,
    content: {
      _id: contentId,
    },
    sent: false,
    sendAt: sendAt ? new Date(sendAt.valueOf()) : new Date(),
  };
}
